// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qJko","importantInfo":"styles_importantInfo__3npHN"};